import React, {useContext, useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {Divider, message, Result, Table} from 'antd';
import './receipt.scss';
import {getTokenHeader, replaceUrlByParams, setTokenHeader} from "../../utils/api";
import {PAGE, TIME_FORMAT} from "../../utils/constants";
import {adminReceipt} from "../../apis/admin";
import moment from "moment";
import Cookies from 'universal-cookie';
import Text from "antd/es/typography/Text";
import {receipt} from "../../apis/result";
import {AppContext} from "../../App";
import {paymentMethodText} from "../../components/paymentStatusTemplate/paymentStatusTemplate";
import {setting} from "../../apis/setting";

function ReceiptPage() {
    let history = useHistory()
    const cookies = new Cookies();
    const {portal, pid, id} = useParams()
    const {setLoading} = useContext(AppContext);
    const {adminToken} = getTokenHeader()
    setTokenHeader(adminToken, cookies.get('publicToken'))
    const loginPage = portal === 'admin' ? PAGE.ADMIN_LOGIN :  portal === 'user' ? `${replaceUrlByParams(PAGE.USER_LOGIN, {':pid': pid})}` : PAGE.ERROR

    const [logo, setLogo] = useState('');
    const [receiptData, setReceiptData] = useState({
        result: [],
        items: []
    });


    useEffect(() => {
       getLogo()
       getReceipt()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getLogo = async () => {
        try {
            const res = await setting(pid);
            if (res.error) {
                history.push({
                    pathname: PAGE.ERROR,
                    state: {
                        status: '404',
                        message: '課程不存在',
                        path: '',
                        button: ''
                    }
                })
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setLogo(res.configuration.logo)
            }
        } catch(e) {
            console.error(e);
        }
    }

    const getReceipt = async () => {
        setLoading(true)

        let api;
         if(portal === 'admin') {
            api = () => adminReceipt(pid, id);
        }else if(portal === 'user'){
            api = () => receipt();
        }else{
            history.push(PAGE.ERROR)
        }
        try {
            const res = await api();

            if (res.error || res.applicationNumber !== id) {
                message.error('登入錯誤，請重新登入', 2,  () => history.push(loginPage))

                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setReceiptData({
                    ...res,
                    ...res.payment,
                    remarks: res.remarks,
                    paymentRemarks: res.payment.remarks,
                })
            }
        } catch (e) {
            console.error(e);
        }finally{
            setLoading(false)
        }
};

    const columns = [
        {
            title: '項目',
            dataIndex: 'item',
            key: 'item',
        },
        {
            title: '內容',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '款項',
            dataIndex: 'amount',
            key: 'amount',
        }
    ];

    const data = receiptData.items.map((item, i) => {
        return {
            key: i,
            item: i + 1,
            content: item.title,
            amount: `HKD ${item.amountInCents / 100}`
        }
    })

    return (
        <>
        {receiptData.result.length > 0 &&(
            <div className='receipt-page'>

                <Result
                    icon={<img src={logo}/>}
                >
                    {receiptData.backgroundLogo && <div className='watermark'><img src={receiptData.backgroundLogo} /></div>}
                    <div className='flex-table col2'>
                        <Divider orientation='left' className='table-title'>收據資料</Divider>

                        {
                            receiptData.result.map((info, i) => {
                                return(
                                    <div key={i} className='cell'>
                                        <div className='label'>{info.name}</div>
                                        <div className='value'>{info.value}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <Table columns={columns} dataSource={data} pagination={false} bordered={false}/>

                    <div className='flex-table col2'>
                        <Divider orientation='left' className='table-title'>付款</Divider>

                        <div className='cell'>
                            <div className='label'>申請編號</div>
                            <div className='value'>{receiptData.applicationNumber}</div>
                        </div>

                        <div className='cell'>
                            <div className='label'>申請遞交時間</div>
                            <div className='value'>{moment(receiptData.applicationTimestamp).format(TIME_FORMAT)}</div>
                        </div>



                        {/*<div className='cell'>*/}
                        {/*    <div className='label'>付款狀態</div>*/}
                        {/*    <div className='value'>{receiptData.status}</div>*/}
                        {/*</div>*/}

                        {/*<div className='cell'>*/}
                        {/*    <div className='label'>付款時間</div>*/}
                        {/*    <div className='value'>{moment(receiptData.paymentTimestamp).format(TIME_FORMAT)}</div>*/}
                        {/*</div>*/}

                        <div className='cell'>
                            <div className='label'>付款編號</div>
                            <div className='value'>{receiptData.paymentNumber}</div>
                        </div>

                        <div className='cell'>
                            <div className='label'>付款方式</div>
                            <div className='value'>{paymentMethodText(receiptData.paymentMethod)}</div>
                        </div>

                        <div className='cell'>
                            <div className='label'>備註</div>
                            <div className='text-area-description value'>{receiptData.paymentRemarks}</div>
                        </div>
                    </div>

                    <div className='total'>
                        <div className='remarks text-area-description'>Remarks: {receiptData.remarks}</div>
                        <div className='amount'>總計: HKD {receiptData.paymentAmountInCents / 100}</div>
                    </div>

                </Result>

                <div className='footer'>
                    <Text className='note'>{receiptData.footer}</Text>
                    <div className='sign'>
                    <Text>此收據為電腦發出</Text>
                    </div>
                </div>
            </div>
        )}
        </>

    )
}

export default ReceiptPage;
